module.exports = __webpack_public_path__ + "static/media/02_web_marketing-invitation.1aeba1f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_marketing-invitation.jpg
// module id = 63
// module chunks = 0